import { render } from "./DiagnosisRepairTask.vue?vue&type=template&id=4d5629f6&scoped=true&ts=true&lang=pug"
import script from "./DiagnosisRepairTask.vue?vue&type=script&lang=ts"
export * from "./DiagnosisRepairTask.vue?vue&type=script&lang=ts"

import "./DiagnosisRepairTask.vue?vue&type=style&index=0&id=4d5629f6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5629f6"]])

export default __exports__